export default __webpack_public_path__ + "static/media/key-icon.33216836.svg";